import { useEffect } from "react";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export const EnterpriseCompanyForm = () => {
  const { register, formState: { errors }, control, setValue } = useFormContext();

  const currencyOptions = [
    { value: "USD", label: "US Dollar (USD)" },
    { value: "EUR", label: "Euro (EUR)" },
    { value: "GBP", label: "British Pound (GBP)" },
    { value: "CAD", label: "Canadian Dollar (CAD)" },
    { value: "AUD", label: "Australian Dollar (AUD)" },
    { value: "INR", label: "Indian Rupee (INR)" },
    { value: "JPY", label: "Japanese Yen (JPY)" },
    { value: "CNY", label: "Chinese Yuan (CNY)" },
  ];

  const paymentMethod = [
    {value: "paypal", label: "Paypal"},
    {value: "crypto", label: "Cryptocurrency"},
  ]

  const preferredPaymentMethod = useWatch({
    control,
    name: "preferredPaymentMethod",
  });

  // Auto-set currency if PayPal
  useEffect(() => {
    if (preferredPaymentMethod === "paypal") {
      setValue("preferredCurrency", "USD");
    }
  }, [preferredPaymentMethod, setValue]);

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="companyName">Company Name <span className="text-red-600">*</span></Label>
        <Input
          id="companyName"
          placeholder="e.g., ABC Corp"
          {...register("companyName")}
          className="border-blue-100 focus:border-emerald-300 focus:ring-1 focus:ring-emerald-300"
        />
        {errors.companyName && (
          <p className="text-xs text-red-500">{String(errors.companyName.message)}</p>
        )}
      </div>
      <div className="space-y-2">
        <Label htmlFor="industryType">Industry Type <span className="text-red-600">*</span></Label>
        <Input
          id="industryType"
          placeholder="e.g., Technology, Finance"
          {...register("industryType")}
          className="border-blue-100 focus:border-emerald-300 focus:ring-1 focus:ring-emerald-300"
        />
        {errors.industryType && (
          <p className="text-xs text-red-500">{errors.industryType.message?.toString()}</p>
        )}
      </div>
      <div className="space-y-2">
        <Label htmlFor="preferredPaymentMethod">Preferred Payment Method</Label>
        <Controller
          name="preferredPaymentMethod"
          control={control}
          render={({ field }) => (
            <Select
              onValueChange={field.onChange}
              value={field.value || ""}
            >
              <SelectTrigger
                id="preferredPaymentMethod"
                className="border-blue-100 focus:border-emerald-300 focus:ring-1 focus:ring-emerald-300"
              >
                <SelectValue placeholder="Select a preferred currency" />
              </SelectTrigger>
              <SelectContent>
                {paymentMethod.map((option) => (
                  <SelectItem key={option.value} value={option.value}>
                    {option.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          )}
        />
        {errors.preferredPaymentMethod && (
          <p className="text-xs text-red-500">{errors.preferredPaymentMethod?.message?.toString()}</p>
        )}
      </div>
      <div className="space-y-2">
        <div className="flex items-center">
          <Label
            htmlFor="preferredCurrency"
            className="font-medium text-sm text-gray-700"
          >
            Preferred Currency
          </Label>
          <div className="relative group ml-2">
            <div className="hidden group-hover:block absolute -top-1 left-6 p-2 w-60 text-xs text-gray-600 bg-white rounded shadow-md z-10">
              Your primary area of expertise.
            </div>
          </div>
        </div>
        <Controller
          name="preferredCurrency"
          control={control}
          render={({ field }) => (
            <Select
              onValueChange={field.onChange}
              value={field.value || ""}
            >
              <SelectTrigger
                id="preferredCurrency"
                className="border-blue-100 focus:border-emerald-300 focus:ring-1 focus:ring-emerald-300"
              >
                <SelectValue placeholder="Select a preferred currency" />
              </SelectTrigger>
              <SelectContent>
                {currencyOptions.map((option) => (
                  <SelectItem key={option.value} value={option.value}>
                    {option.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          )}
        />
        {errors.preferredCurrency && (
          <p className="text-xs text-red-500">
            {errors.preferredCurrency.message as string}
          </p>
        )}
      </div>
      <div className="space-y-2">
        <Label htmlFor="vatOrGstId">VAT/GST ID </Label>
        <Input
          id="vatOrGstId"
          placeholder="e.g., VAT123456789"
          {...register("vatOrGstId")}
          className="border-blue-100 focus:border-emerald-300 focus:ring-1 focus:ring-emerald-300"
        />
        {errors.vatOrGstId && (
          <p className="text-xs text-red-500">{errors.vatOrGstId?.message?.toString()}</p>
        )}
      </div>
      <div className="space-y-2">
        <Label htmlFor="socialMediaProfile">Comapny Website (Optional)</Label>
        <Input
          id="socialMediaProfile"
          placeholder="e.g., https://linkedin.com/company/example"
          {...register("socialMediaProfile")}
          className="border-blue-100 focus:border-emerald-300 focus:ring-1 focus:ring-emerald-300"
        />
        {errors.socialMediaProfile && (
          <p className="text-xs text-red-500">{typeof errors.socialMediaProfile?.message === "string" && errors.socialMediaProfile.message}</p>
        )}
      </div>
    </div>
  );
};